// import { Box } from "@twilio-paste/core/box";
import { CloseIcon } from "@twilio-paste/icons/esm/CloseIcon";
import { Text } from "@twilio-paste/core/text";
import { Anchor } from "@twilio-paste/core/anchor";
import { MouseEvent } from 'react'
import { useSelector } from "react-redux";

import { AppState } from "../store/definitions";
import { sessionDataHandler } from "../sessionDataHandler";
import { containerStyles, titleStyles } from "./styles/Header.styles";

export const Header = ({ active, customTitle }: { active?: boolean, customTitle?: string }) => {
  const { conversation } = useSelector((state: AppState) => ({
    conversation: state.chat.conversation,
  }));


  const endConversation = async (e: MouseEvent) => {
    e.preventDefault()
    if (conversation) {

      try {
        const data = await sessionDataHandler.endConversation(
          {
            conversationSid: conversation.sid
          }
        )
        console.log("data", data)
      } catch (err) {
        console.log(err)
      }
    }

  }

  return (
    <header 
    // as="header"  
    style={containerStyles}>
      {/* <div style={{ width: '100%', height: '100%', backgroundColor: 'white', color: 'black' }}> */}
      < Text as="h2" {...titleStyles}>
        {customTitle || "Cuidados Pela Vida"
        }
      </Text >
      {
        active ?
          //eslint-disable-next-line
          <Anchor href="" onClick={(e) => (endConversation(e))}>
            < Text as="h2" {...titleStyles}>
            < CloseIcon decorative={false} title="Fechar Conversa" />
            </Text >
          </Anchor >
          : null
      }

      {/* </div> */}
    </header>
  );
};
